module.exports = __webpack_public_path__ + "static/harvesting-the-biosphere-ab15e68cdca026ec3f7ab2f6c4954ded.jpg";